import { getElementPosition } from '@bydesign-ui/hooks';
export function calElemHitWithMousePos(elem, pos) {
  if (elem.nodeType !== 1) {
    return false;
  }

  var _getElementPosition = getElementPosition(elem),
      left = _getElementPosition.left,
      top = _getElementPosition.top,
      right = _getElementPosition.right,
      bottom = _getElementPosition.bottom,
      height = _getElementPosition.height,
      width = _getElementPosition.width;

  var clientX = pos.clientX,
      clientY = pos.clientY;

  if (clientX < left || clientX > right || clientY < top || clientY > bottom) {
    return false;
  }

  return {
    vertical: top + height / 2 > clientY ? 'top' : 'bottom',
    horizontal: left + width / 2 > clientX ? 'left' : 'right',
    offsetTop: clientY - top,
    offsetLeft: clientX - left,
    offsetBottom: bottom - clientY,
    offsetRight: right - clientX
  };
}